module.exports = __webpack_public_path__ + "img/medical.bdf07f8c.svg";